import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ProfileScreenOverview').create(({ theme }) => ({
  root: {
    width: '100%',
    gap: '12px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },

  rootWrapper: {
    width: '100%',
  },
  favContainer: {
    display: 'flex',
    fontFamily: 'Space Grotesk',
    flexDirection: 'column',
    backgroundColor: '#B0B1B81F',
    borderRadius: '12px',
    padding: '20px',
    height: '106px',

    gap: '12px',
    cursor: 'pointer',
  },
  statContainer: {
    display: 'flex',
    fontFamily: 'Space Grotesk',
    flexDirection: 'column',
    backgroundColor: '#B0B1B81F',
    borderRadius: '12px',
    padding: '20px',
    height: '106px',
    gap: '12px',
  },
  title: {
    textTransform: 'uppercase',
    margin: '0',
    fontFamily: 'Inter',
    fontWeight: 370,
    fontStyle: 'normal',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    zIndex: 2,
    textAlign: 'left',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },

  value: {
    margin: '0',
    fontFamily: 'Space Grotesk',
    fontSize: '22px',
    fontWeight: '470',
    lineHeight: theme.sizes.texts.lineHeight.l,

    span: {
      fontFamily: 'Inter',
    },
  },

  basicValue: {
    fontSize: '22px',
    fontWeight: '470',
    lineHeight: theme.sizes.texts.lineHeight.l,
  },

  featuresContainer: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  },

  plusTextContainer: {
    display: 'flex',
    zIndex: 2,
    paddingTop: '20px',
    paddingBottom: '12px',
    gap: '6px',
  },

  valueWrapper: {
    display: 'flex',
    gap: '6px',
    span: {
      fontSize: '22px',
      fontWeight: '470',
      lineHeight: theme.sizes.texts.lineHeight.l,
    },
  },

  lockWrapper: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    opacity: '1!important',
    justifyContent: 'center',
    top: '8px',
    zIndex: 2,
  },

  recomendedWrapper: {
    position: 'absolute',
    right: '0',
    bottom: '0px',
    padding: '20px',
    display: 'flex',
    gap: '8px',
    pointerEvents: 'none',
  },

  favoriteGenreWrapper: {
    width: 'fit-content',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    pointerEvents: 'none',
  },

  modalRoot: {
    position: 'fixed',
    padding: '14px 16px',
    zIndex: '100',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.background.primary,

    ':after': {
      content: "''",
      position: 'absolute',
      top: '20px',
      right: '400px',
      width: '50%',
      aspectRatio: '1/1',
      borderRadius: '9999px',
      filter: 'blur(180px)',
      background: 'conic-gradient(from 180deg at 50% 50%, #488DFF 0deg, #3EAFE7 174.62deg, #BFBFBF 360deg)',
    },

    h1: {
      fontSize: theme.sizes.texts.fontSize.l,
      margin: '0px',
      marginBottom: '32px',
      marginTop: '12px',
      fontWeight: '450',
      lineHeight: theme.sizes.texts.lineHeight.xl,

      textAlign: 'center',
    },
  },

  gamesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },

  modalBtn: {
    width: '100%',
    height: theme.sizes.button.height,
    position: 'relative',
    right: '3.9%',
    background: 'transparent',
    color: theme.colors.button.secondary.text,
    border: '1.5px solid',
    borderColor: theme.colors.borders.default,
    boxShadow: 'none',
  },

  favGenre: {
    display: 'block',
    width: '100%',
    position: 'relative',
    left: '0',
  },
}))
